import { defineComponent as _defineComponent } from 'vue'
import { useStore } from '@/vueAdapterUtils/utils';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ribbon',
  setup(__props) {

const store = useStore();

const ribbonEnv = computed(() => store.getters.ribbonOnProfiles);
const ribbonEnabled = computed(
  () =>
    store.getters.ribbonOnProfiles &&
    store.getters.activeProfiles.indexOf(store.getters.ribbonOnProfiles) > -1
);

return { __sfc: true,store, ribbonEnv, ribbonEnabled }
}

})